import { render, staticRenderFns } from "./recommendCoupon.vue?vue&type=template&id=487fb724&scoped=true&"
import script from "./recommendCoupon.vue?vue&type=script&lang=js&"
export * from "./recommendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./recommendCoupon.vue?vue&type=style&index=0&id=487fb724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fb724",
  null
  
)

export default component.exports